<template>
  <v-card>
    <v-card-title
      class="
          pa-0
          pl-2
          text-xs-h6         
          text-sm-h6         
          text-md-h6          
          text-lg-h6      
          text-xl-h4"
      >
      <v-list-item-avatar 
        border size="35"
        style="border: 2px solid green; border-radius: 50%; overflow: hidden;"

      >
        <v-img :src="article.user.profile.profile_image"></v-img>
      </v-list-item-avatar>   
      <v-row>
          <div>
            <v-bottom-sheet width="1200px" height="900px" v-model="sheet">
              <template v-slot:activator="{ on, attrs }">
                 <v-btn elevation="0" v-bind="attrs" color="transparent" density="compact"
                  class="pb-2 pl-2 pr-2 pt-2">
                  <span class="
                      text-xs-caption         
                      text-sm-subtitle-2         
                      text-md-subtitle-2          
                      text-lg-subtitle-2      
                      text-xl-h6
                    ">
                    {{ createSubstr(article.user.first_name) + " " + (article.user.last_name) }}
                  </span>
                </v-btn>
              </template>
              <profilePage :userId="article.user.id" />
            </v-bottom-sheet>
            <div style="margin-top: -20px;">
              <span class="text-caption pl-1 pt-1 font-weight-light">
                <v-icon color="red" size="20">mdi-map-marker</v-icon>
                  <a :href="'https://www.google.com/search?q=' + countryName" style="text-decoration:none; color: black;"
                    target="_blank">{{ countryName }} </a>
                <!--<span>{{ countryEmoji }}</span>-->
              </span>
            </div>
          </div>
      </v-row>
      <!--
      Will work on this function in the future. It was wokrking but I changed the code.
      <v-list-item-action v-if="$vuetify.breakpoint.mdAndUp">
        <v-switch inset v-model="localCycle" append-icon="mdi-page-next" class="pa-0" color="blue darken-2" hide-details></v-switch>
      </v-list-item-action>
      -->
      <v-card-actions>
        <span dense class="text-subtitle-2 grey--text d-flex align-center pr-0 mr-0">
          <v-icon dense class="pl-0 ml-0">mdi-circle-small</v-icon>
          {{ getTime(article.created_at) }}
        </span>
        <v-btn class="pl-2" x-small icon @click="handleCloseWindow">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card-title>
    <!-- This code will make the news toggle-->
    <!--@click="toggleNewsPageOverlay(); saveArticleAdress(article.url);">-->
    <!--<a :href="'' + article.files" target="_blank">-->
    <v-card-text class="pa-0" v-if="article.files === null"></v-card-text>
    <!-- Make image and text scroll together -->
    <div :style="{ maxHeight: $vuetify.breakpoint.mdAndUp ? '380px' : '100%', overflowY:'auto' }">
      <!--</a>-->
      <v-img v-if="article.files" 
        :src="article.files" 
        :aspect-ratio="$vuetify.breakpoint.smAndDown ? undefined : 12/6"
        width="100%"
        :height="$vuetify.breakpoint.smAndDown ? '200px' : '300px'" 
        @click="openImage(article.files)">
        <video v-if="isVideo(article.files) && article.files.includes('mov')"  :height="postPingHeight" :width="postPingWidth" class="pa-0 elevation-0" controls muted autoplay>
          <source :src="article.files" />
          <v-btn color="white" text small class="white--text float-right"
            @click="overlay = true"><v-icon>mdi-eye-off-outline</v-icon>
          </v-btn>
          <v-overlay absolute width="500" :opacity="opacity" :value="overlay">
            <p class="text-md-center"><v-icon>mdi-eye-off</v-icon>
            </p>
            <p class="text-md-center">Content Warning: Sensitive Content.<br />
              Triyangle flagged this post for sensitive content.<br />
            </p>
            <v-btn color="white" text small outlined rounded class="white--text float-right" @click="overlay = false">
              Show
            </v-btn>
          </v-overlay>
        </video>
        <v-dialog 
            :fullscreen="$vuetify.breakpoint.smAndDown"
            :width="$vuetify.breakpoint.mdAndUp ? 800 : '100%'"
            :height="$vuetify.breakpoint.mdAndUp ? 400 : 'mx-auto'" 
            transition="fade-transition"
            v-model="imgDialog">
          <v-card>
          <v-img  
            v-if="article.files" 
            :lazy-src="article.files" :src="article.files">
            <v-btn elevation="0" fab x-small outlined color="grey" class="close-button" @click="imgDialog = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </v-img>
          <video
            v-if="article.files && article.files.includes('mov')" 
            :fullscreen="$vuetify.breakpoint.smAndDown"
            :width="$vuetify.breakpoint.mdAndUp ? 800 : '100%'"
            :height="$vuetify.breakpoint.mdAndUp ? 400 : 'mx-auto'"
            fullscreen  
            class="pa-0" 
            controls muted autoplay>
            <source :src="article.files" />
          </video>  
          </v-card>
        </v-dialog>
      </v-img>
      <v-card-text
        class="
        contentArea
        black--text
        pl-3 pr-3 pt-1
        pb-0 
        "
      >
      <!--Translate text-->
      <v-row class="pb-0 pt-1">
        <v-col cols="12" md="12" v-if="article.content !== null && article.content !== ''">
          <!-- Toggle button -->
            <div class="text-caption font-weight-bold blue--text"
              style="cursor: pointer"
              @click="toggleTranslation(article.id)">
              {{ showingTranslated ? 'Show Original' : 'Translate Post' }}
            </div>
        
        <!-- Display text -->
          <v-card 
            class="pb-0 pt-0"
            elevation="0" 
            style="background-color:rgba(255, 255, 255, 0.001)"
          >
            <v-card-text 
              class="black--text font-weight-normal pl-0 pr-0 pt-0">
              <!-- Conditionally show full or partial text -->
              <span v-if="showFullContent">
                {{ showingTranslated ? translatedText : article.content.trimStart() }}
                <a :href="'' + article.link" target="_blank">{{ article.link }}</a>
              </span>
              <span v-else>
                {{ showingTranslated ? createContentSubstr(translatedText) : createContentSubstr(article.content.trimStart()) }}
              </span>
              <!-- Read More / Show Less toggle -->
              <v-btn
                x-small
                text
                color="primary"
                class="pl-0 float-right"
                @click="toggleReadMore"
              >
                {{ showFullContent ? ' Show Less' : ' Read More...' }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-card-actions v-if="$vuetify.breakpoint.smAndDown" class="pb-1 pt-5 pl-0 buttonsArea">
        <v-list-item>
          <v-row align="center"
            justify="space-between"
            class="flex-wrap"
            style="width: 100%;">
            <!-- Replace textarea with icon trigger -->
            <v-icon @click="replyMode = true" color="blue">mdi-reply-all</v-icon>
            <!-- Fullscreen reply composer -->
            <v-dialog
              persistent
              v-model="replyMode"
              :fullscreen="$vuetify.breakpoint.smAndDown"
              max-width="500"
              transition="dialog-bottom-transition"
            >
              <v-card color="white" class="pa-0">
                <!-- Header -->
                <v-card-actions class="px-2 pt-2">
                  <v-btn icon @click="closeReply">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    class="rounded-pill white--text"
                    :disabled="!comment"
                    @click="addComment(article.id)"
                  >
                    Ping<v-icon color="red">mdi-circle-slice-8</v-icon>
                  </v-btn>
                </v-card-actions>
                <!-- “Ping” Summary (Post Preview) -->
                <v-card
                  flat
                  class="mx-3 my-3 rounded-xl"
                  color="#f5f8fa"
                >
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold text-subtitle-2">
                        <v-list-item-avatar size="36" class="mr-1 ml-1">
                          <v-img :src="article.user.profile.profile_image"></v-img>
                        </v-list-item-avatar>
                        <span class="grey--text text--darken-1">
                          @ {{ article.user.first_name }} {{ article.user.last_name }}
                        </span>
                      </v-list-item-title>

                      <div class="content-with-image">
                        <span
                          class="text-body-2 grey--text text--darken-2 mt-1"
                        >
                          {{ article.content.length > 100
                            ? article.content.slice(0, 200) + '…'
                            : article.content }}

                          <v-img
                            v-if="article.files"
                            :src="article.files"
                            class="mt-2 rounded-lg float-left wrapped-image"
                            max-width="150"
                            max-height="120"
                          ></v-img>
                        </span>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>

                <!-- Reply Input Section -->
                <v-list-item class="pt-4 align-start">
                  <!-- Your Profile Avatar -->
                  <v-list-item-avatar class="mr-0" size="40">
                    <v-img :src="profile_image"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-textarea
                      v-model="comment"
                      placeholder="Ping your reply"
                      auto-grow
                      clearable
                      solo
                      flat
                      rows="2"
                      class="mt-1"
                      hide-details
                      @keydown.enter.exact.prevent="addComment(article.id)"
                    ></v-textarea>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-dialog>
            <v-icon size="20" color="grey" class="mr-0">
              mdi-eye-outline
            </v-icon>
            <span class="subheading">{{ article.views }}</span>
              <v-icon size="20" v-if="$vuetify.breakpoint.smAndDown" @click="toggleCommentSection()" color="grey" class="mr-0">
                mdi-comment-outline
              </v-icon>
              <v-icon v-else color="grey" class="mr-0">
                mdi-comment-outline
              </v-icon>
              <span class="subheading mr-0">{{ article.comments.length }}</span>
              <!--<likeButton :articleId="article.id"/>-->
              <v-btn class="pl-0" @click="likePost(article.id)" :liked="true" elevation="0" color="transparent" fab
                x-small>
                <v-icon class="pl-0" :color="liked ? 'red' : 'grey'">
                  {{ liked ? 'mdi-heart' : 'mdi-heart-outline' }}
                </v-icon>
              </v-btn>
              <span class="pr-0">{{ totalLikes }}</span>
              <!--This section will be used for repost when the time comes.-->

              <v-btn 
                @click="repost(article.id)" 
                :reposted="true" 
                color="transparent" 
                elevation="0" 
                fab 
                x-small
              >
                  <v-icon :color="reposted ? 'red' : 'grey'">
                    mdi-selection-marker
                  </v-icon>
                  <span class="subheading pl-0">{{ totalRepost }}</span>
              </v-btn>

              <!--I have to start working on this.-->
              <v-speed-dial v-model="fab">
                <template v-slot:activator>
                  <v-btn v-model="fab" color="transparent" elevation="0" fab x-small>
                    <v-icon color="grey" v-if="fab">
                      mdi-close
                    </v-icon>
                    <v-icon color="grey" v-else>
                      mdi-share-variant
                    </v-icon>
                  </v-btn>
                </template>
                <v-btn fab dark small color="primary">
                  <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + article.link" target="_blank">
                    <v-icon color="white">mdi-linkedin</v-icon>
                  </a>
                </v-btn>
                <v-btn fab dark small color="green">
                  <a :href="'https://api.whatsapp.com/send?text=' + article.link" target="_blank"
                    data-action="share/whatsapp/share">
                    <v-icon color="white">mdi-whatsapp</v-icon>
                  </a>
                </v-btn>
                <v-btn fab dark small color="primary">
                  <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + article.link" target="_blank">
                    <v-icon color="white">mdi-facebook</v-icon>
                  </a>
                </v-btn>
              </v-speed-dial>
              <span class="subheading">{{ article.shares }}</span>
              <v-dialog
                v-model="showForm"
                transition="dialog-bottom-transition"
                :fullscreen="$vuetify.breakpoint.smAndDown"
                :overlay-opacity="0"
                max-width="500"
                persistent
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab v-bind="attrs" v-on="on" x-small class="elevation-0 pl-0 pr-0">
                    <v-icon color="green">mdi-currency-usd</v-icon>
                  </v-btn>
                </template>
                <donationLink @close-dialog="showForm = false" />
              </v-dialog>
          </v-row>
        </v-list-item>
      </v-card-actions>
      </v-card-text>
      <v-card-text v-if="$vuetify.breakpoint.mdAndUp && showCommentSection" class="pb-0 pt-0 pl-0">
        <v-card-subtitle class="pb-0"> {{ article.comments.length }} Comment(s)</v-card-subtitle>
        <commentSection :comments="article.comments" />
      </v-card-text>  
      <!-- Comment Fullscreen Overlay -->
      <v-dialog
        v-if="$vuetify.breakpoint.smAndDown"
        fullscreen
        v-model="showCommentSection"
        transition="dialog-bottom-transition"
        hide-overlay
      >
        <v-card class="pa-0">
          <!-- Header -->
          <v-toolbar color="white" dense flat>
            <v-btn icon @click="showCommentSection = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ article.comments.length }} Comment(s)</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <!-- Scrollable Content -->
          <v-card-text class="pb-0 pt-0 pl-0" style="height: calc(100vh - 64px); overflow-y: auto;">
            <commentSection :comments="article.comments" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-card-actions v-if="$vuetify.breakpoint.mdAndUp" class="pb-1 pt-0 buttonsArea">
      <v-list-item>
        <v-row align="center" justify="space-between" 
          style="width: 100%; flex-wrap: wrap;">
          <v-btn icon @click="replyMode = true">
            <v-icon color="blue">mdi-reply</v-icon>
          </v-btn>
          <span class="pl-0 grey--text text--darken-1">Reply</span>
          <v-icon color="grey" class="mr-1">
            mdi-eye-outline
          </v-icon>
          <span class="subheading mr-1">{{ article.views }}</span>
          <v-icon @click="toggleCommentSection()" color="grey" class="mr-1">
            mdi-comment-outline
          </v-icon>
          <span class="subheading mr-1">{{ article.comments.length }}</span>
          <!--<likeButton :articleId="article.id"/>-->
          <v-btn @click="likePost(article.id)" :liked="true" elevation="0" color="transparent" fab
            small>
            <v-icon :color="liked ? 'red' : 'grey'">
              {{ liked ? 'mdi-heart' : 'mdi-heart-outline' }}
            </v-icon>
          </v-btn>
          <span class="subheading mr-1">{{ totalLikes }}</span>
          <!--This section will be used for repost when the time comes.-->
          <v-btn  @click="repost(article.id)" :reposted="true" color="transparent" elevation="0" fab small>
            <v-icon :color="reposted ? 'red' : 'grey'">
              mdi-selection-marker
            </v-icon>
          </v-btn>
          <span class="subheading mr-0">{{ totalRepost }}</span>
          <v-speed-dial v-model="fab">
            <template v-slot:activator>
              <v-btn v-model="fab" color="transparent" elevation="0" fab x-small>
                <v-icon color="grey" v-if="fab">
                  mdi-close
                </v-icon>
                <v-icon color="grey" v-else>
                  mdi-share-variant
                </v-icon>
              </v-btn>
            </template>
            <v-btn fab dark small color="primary">
              <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + article.link" target="_blank">
                <v-icon color="white">mdi-linkedin</v-icon>
              </a>
            </v-btn>
            <v-btn fab dark small color="green">
              <a :href="'https://api.whatsapp.com/send?text=' + article.link" target="_blank"
                data-action="share/whatsapp/share">
                <v-icon color="white">mdi-whatsapp</v-icon>
              </a>
            </v-btn>
            <v-btn fab dark small color="primary">
              <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + article.link" target="_blank">
                <v-icon color="white">mdi-facebook</v-icon>
              </a>
            </v-btn>
          </v-speed-dial>
          <span class="subheading">{{ article.shares }}</span>
        </v-row>
      </v-list-item>
      <!-- Inline compact version -->
      <v-list-item-action v-if="!replyMode && $vuetify.breakpoint.mdAndUp" class="pl-0 pr-1 ">
        <v-dialog
          v-model="showForm"
          transition="dialog-bottom-transition"
          :fullscreen="$vuetify.breakpoint.smAndDown"
          :overlay-opacity="0"
          max-width="500"
          persistent
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab v-bind="attrs" v-on="on" x-small class="elevation-0 pl-0 pr-0">
              <v-icon color="green">mdi-currency-usd</v-icon>
            </v-btn>
          </template>
          <donationLink @close-dialog="showForm = false" />
        </v-dialog>
      </v-list-item-action>
    </v-card-actions>
    <!--Comment Section
      <v-card class="ml-0 pb-1 pt-0 rounded-t-0" color="#1565C0" fluid max-width="500" max-height="400" dark>
        <v-card-actions class="pb-0">
          <v-list-item>
            <v-bottom-sheet width="1200px" v-model="sheet">
              <template v-slot:activator="{ on, attrs }">
                <v-btn small class="pl-0 pr-0" elevation="0" v-bind="attrs" v-model="sheet" v-on="on" color="transparent"
                  density="compact" box-shadow="0px" @click="toggleProfilePage">
                  <v-list-item-avatar size="40" class="v-img">
                    <v-img :src="profile_image" alt="avatar"></v-img>
                  </v-list-item-avatar>
                </v-btn>
              </template>
              <profilePage />
            </v-bottom-sheet>
            <v-textarea type="text" v-model="comment" clear-icon="mdi-close-circle" @click:append="addComment(article.id)"
              @keyup.enter="addComment(article.id)" placeholder="What are your thoughts?" clearable auto-grow counter
              filled class="
                      text-overline max-height-textarea white--text" rows="1" rounded dense hide-details>
            </v-textarea>
            <v-list-item-action>
              <v-dialog v-model="dialog" width="800">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" small color="red" dark>
                    <v-icon>mdi-currency-usd</v-icon>
                  </v-btn>
                </template>
                <donationLink />
              </v-dialog>
            </v-list-item-action>
          </v-list-item>
        </v-card-actions>
      </v-card>
      -->
    <v-card
      class="ml-0 pb-0 pt-0 rounded-t-0"
      fluid
      bordered
      max-width="500"
      light
    >
      <!-- Fullscreen reply composer -->
      <v-dialog
        persistent
        v-model="replyMode"
        :fullscreen="$vuetify.breakpoint.smAndDown"
        max-width="500"
        transition="dialog-bottom-transition"
      >
        <v-card color="white" class="pa-0">
          <!-- Header -->
          <v-card-actions class="px-2 pt-2">
            <v-btn icon @click="closeReply">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="rounded-pill white--text"
              :disabled="!comment"
              @click="addComment(article.id)"
            >
              Ping<v-icon color="red">mdi-circle-slice-8</v-icon>
            </v-btn>
          </v-card-actions>
          <!-- “Ping” Summary (Post Preview) -->
          <v-card
            flat
            class="mx-3 my-3 rounded-xl"
            color="#f5f8fa"
          >
            <v-list-item dense>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold text-subtitle-2">
                  <v-list-item-avatar size="36" class="mr-1 ml-1">
                    <v-img :src="article.user.profile.profile_image"></v-img>
                  </v-list-item-avatar>
                  <span class="grey--text text--darken-1">
                    {{ article.user.first_name }} {{ article.user.last_name }}
                  </span>
                </v-list-item-title>

                <div class="content-with-image">
                  <span
                    class="text-body-2 grey--text text--darken-2 mt-1"
                  >
                    {{ article.content.length > 100
                      ? article.content.slice(0, 200) + '…'
                      : article.content }}

                    <v-img
                      v-if="article.files"
                      :src="article.files"
                      class="mt-2 rounded-lg float-left wrapped-image"
                      max-width="150"
                      max-height="120"
                    ></v-img>
                  </span>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>

          <!-- Reply Input Section -->
          <v-list-item class="pt-4 align-start">
            <!-- Your Profile Avatar -->
            <v-list-item-avatar class="mr-0" size="40">
              <v-img :src="profile_image"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-textarea
                v-model="comment"
                placeholder="Ping your reply"
                auto-grow
                clearable
                solo
                flat
                rows="2"
                class="mt-1"
                hide-details
                @keydown.enter.exact.prevent="addComment(article.id)"
              ></v-textarea>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-dialog>

      <v-divider color="blue" style="height:6px;"></v-divider>
    </v-card>
  </v-card>
</template>
<script>
import axios from 'axios'
import { translateText } from "@/services/translationService";
import commentSection from './commentSection'
import profilePage from './profilePage'
//import likeButton from './likeButton'
// import profilePost from './profilePost'
import donationLink from './donationLink'
import { apiUrl } from '../config'

const moment = require('moment')
moment().format()
moment.updateLocale('en-short', {
  relativeTime : {
    past: "%s",
    s  : '1 sec ago',
    ss : '%s secs ago',
    m:  "1 min ago",
    mm: "%d mins ago",
    h:  "1 hr ago",
    hh: "%d hrs ago",
    d:  "1 day ago",
    dd: "%d days ago",
    M:  "1 month ago",
    MM: "%d months ago",
    y:  "1 yr ago",
    yy: "%d yrs ago"
  }
});
export default {
  data: () => ({
    showForm: false,
    replyMode: false,
    inputText: '',
    originalText: null,
    showingTranslated: false,
    translatedText: null,
    selectedLanguage: '',
    languages: [
      { text: 'Afrikaans', value: 'af' },
      { text: 'Albanian', value: 'sq' },
      { text: 'Amharic', value: 'am' },
      { text: 'Arabic', value: 'ar' },
      { text: 'Armenian', value: 'hy' },
      { text: 'Azerbaijani', value: 'az' },
      { text: 'Basque', value: 'eu' },
      { text: 'Belarusian', value: 'be' },
      { text: 'Bengali', value: 'bn' },
      { text: 'Bosnian', value: 'bs' },
      { text: 'Bulgarian', value: 'bg' },
      { text: 'Catalan', value: 'ca' },
      { text: 'Cebuano', value: 'ceb' },
      { text: 'Chinese (Simplified)', value: 'zh-CN' },
      { text: 'Chinese (Traditional)', value: 'zh-TW' },
      { text: 'Corsican', value: 'co' },
      { text: 'Croatian', value: 'hr' },
      { text: 'Czech', value: 'cs' },
      { text: 'Danish', value: 'da' },
      { text: 'Dutch', value: 'nl' },
      { text: 'English', value: 'en' },
      { text: 'Esperanto', value: 'eo' },
      { text: 'Estonian', value: 'et' },
      { text: 'Finnish', value: 'fi' },
      { text: 'French', value: 'fr' },
      { text: 'Frisian', value: 'fy' },
      { text: 'Galician', value: 'gl' },
      { text: 'Georgian', value: 'ka' },
      { text: 'German', value: 'de' },
      { text: 'Greek', value: 'el' },
      { text: 'Gujarati', value: 'gu' },
      { text: 'Haitian Creole', value: 'ht' },
      { text: 'Hausa', value: 'ha' },
      { text: 'Hawaiian', value: 'haw' },
      { text: 'Hebrew', value: 'he' },
      { text: 'Hindi', value: 'hi' },
      { text: 'Hmong', value: 'hmn' },
      { text: 'Hungarian', value: 'hu' },
      { text: 'Icelandic', value: 'is' },
      { text: 'Igbo', value: 'ig' },
      { text: 'Indonesian', value: 'id' },
      { text: 'Irish', value: 'ga' },
      { text: 'Italian', value: 'it' },
      { text: 'Japanese', value: 'ja' },
      { text: 'Javanese', value: 'jv' },
      { text: 'Kannada', value: 'kn' },
      { text: 'Kazakh', value: 'kk' },
      { text: 'Khmer', value: 'km' },
      { text: 'Kinyarwanda', value: 'rw' },
      { text: 'Korean', value: 'ko' },
      { text: 'Kurdish', value: 'ku' },
      { text: 'Kyrgyz', value: 'ky' },
      { text: 'Lao', value: 'lo' },
      { text: 'Latin', value: 'la' },
      { text: 'Latvian', value: 'lv' },
      { text: 'Lithuanian', value: 'lt' },
      { text: 'Luxembourgish', value: 'lb' },
      { text: 'Macedonian', value: 'mk' },
      { text: 'Malagasy', value: 'mg' },
      { text: 'Malay', value: 'ms' },
      { text: 'Malayalam', value: 'ml' },
      { text: 'Maltese', value: 'mt' },
      { text: 'Maori', value: 'mi' },
      { text: 'Marathi', value: 'mr' },
      { text: 'Mongolian', value: 'mn' },
      { text: 'Myanmar (Burmese)', value: 'my' },
      { text: 'Nepali', value: 'ne' },
      { text: 'Norwegian', value: 'no' },
      { text: 'Nyanja (Chichewa)', value: 'ny' },
      { text: 'Odia (Oriya)', value: 'or' },
      { text: 'Pashto', value: 'ps' },
      { text: 'Persian', value: 'fa' },
      { text: 'Polish', value: 'pl' },
      { text: 'Portuguese', value: 'pt' },
      { text: 'Punjabi', value: 'pa' },
      { text: 'Romanian', value: 'ro' },
      { text: 'Russian', value: 'ru' },
      { text: 'Samoan', value: 'sm' },
      { text: 'Scots Gaelic', value: 'gd' },
      { text: 'Serbian', value: 'sr' },
      { text: 'Sesotho', value: 'st' },
      { text: 'Shona', value: 'sn' },
      { text: 'Sindhi', value: 'sd' },
      { text: 'Sinhala', value: 'si' },
      { text: 'Slovak', value: 'sk' },
      { text: 'Slovenian', value: 'sl' },
      { text: 'Somali', value: 'so' },
      { text: 'Spanish', value: 'es' },
      { text: 'Sundanese', value: 'su' },
      { text: 'Swahili', value: 'sw' },
      { text: 'Swedish', value: 'sv' },
      { text: 'Tagalog (Filipino)', value: 'tl' },
      { text: 'Tajik', value: 'tg' },
      { text: 'Tamil', value: 'ta' },
      { text: 'Tatar', value: 'tt' },
      { text: 'Telugu', value: 'te' },
      { text: 'Thai', value: 'th' },
      { text: 'Turkish', value: 'tr' },
      { text: 'Turkmen', value: 'tk' },
      { text: 'Ukrainian', value: 'uk' },
      { text: 'Urdu', value: 'ur' },
      { text: 'Uyghur', value: 'ug' },
      { text: 'Uzbek', value: 'uz' },
      { text: 'Vietnamese', value: 'vi' },
      { text: 'Welsh', value: 'cy' },
      { text: 'Xhosa', value: 'xh' },
      { text: 'Yiddish', value: 'yi' },
      { text: 'Yoruba', value: 'yo' },
      { text: 'Zulu', value: 'zu' }
    ],
    API_URL: apiUrl,
    opacity: 1,
    alert: true,
    cycle: false,
    overlay: false,
    postProfileData: [''],
    profile_image: '',
    fab: "",
    onboarding: 0,
    showCommentSection: false,
    showNewsPage: false,
    showProfilePage: false,
    dialog: false,
    imgDialog: false,
    comment: "",
    comments: [],
    // new like variables //
    liked: false,
    // end of like variables //
    postLike: false,
    // totalLikes: this.article.likes,
    totalLikes: 0,
    totalRepost: 0,
    reposted: false,
    articleAddress: "",
    fullScreen: false,
    sheet: "",
    showFullContent: false
  }),

  components: {
    commentSection,
    profilePage,
    // profilePost,
    donationLink,
    //likeButton,
    // PostDetails,
  },
  mounted() {
    // this code is the code thats causing the Server 500 error
    //
    setTimeout(() => {
      this.incrementViews(this.article.id);
    }, 2000);
  },
  props: {
    value: { // 👈 This is what v-model passes down from parent
      type: Boolean,
      default: false
    }
  },
  computed: {
    // Used for slide feature.
    localCycle: {
      get() {
        return this.value; // reflect parent value
      },
      set(val) {
        this.$emit("input", val); // update parent, sync all
      }
    },
    // Change height with different screen sizes
    postPingHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 180;
        case 'sm': return 180;
        case 'md': return 380;
        case 'lg': return 380;
        case 'xl': return 380;
        default: return 380; // Default value if no match
      }
    },
    postPingWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%';
        case 'sm': return '100%';
        case 'md': return 480;
        case 'lg': return 480;
        case 'xl': return 480;
        default: return 480; // Default value if no match
      }
    }
  },
  methods: {
    isVideo(file) {
      return file.includes('mov') || file.includes('mp4') || file.includes('avi');
    },
    openImage(file) {
      if (!this.isVideo(file)) {
        this.imgDialog = true;
      }
    },
    focusInput() {
      this.replyMode = true
    },
    closeReply() {
      this.replyMode = false
    },
     scrollIntoView() {
      // Ensures textarea scrolls into view when keyboard appears on mobile
      this.$nextTick(() => {
        const el = document.activeElement;
        if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    },
    async incrementViews(postId) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        console.log(authToken);
        const response = await axios.get(`${this.API_URL}posts/${postId}/increment_views/`,
        {
          headers: {
            Authorization: authToken
          }
        });
        const updatedViews = response.data.views;

        // Update views in local state
        const postIndex = this.article.findIndex(p => p.id === postId);
        if (postIndex !== -1) {
          this.$set(this.article[postIndex], "views", updatedViews);
        }
      } catch (error) {
        console.error("Error incrementing views:", error);
      }
    },
    async toggleTranslation(articleId) {
      // If already showing translation, toggle back to original
      if (this.showingTranslated) {
        this.showingTranslated = false;
        return;
      }

      // Otherwise, fetch & translate
      try {
        let user = JSON.parse(localStorage.getItem("user"));
        const authToken = "Bearer " + user["access"];

        const response = await axios.get(`${this.API_URL}posts/${articleId}`, {
          headers: { Authorization: authToken }
        });

        this.originalText = response.data.content;

        // detect user language
        const browserLang = navigator.language.split("-")[0];
        this.selectedLanguage = this.languages.includes(browserLang) ? browserLang : "en";

        // translate only if not already done
        if (!this.translatedText) {
          this.translatedText = await translateText(this.originalText, this.selectedLanguage);
        }

        this.showingTranslated = true;
      } catch (error) {
        console.error("Error translating:", error);
        this.translatedText = "Error translating text";
        this.showingTranslated = true;
      }
    },
    /*
    async getProfileData() {
      try {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const authToken = 'Bearer ' + storedUser.access;

        // Get the profile ID from the URL
        const userId = this.userId;
        console.log("Profile user ID:", userId);

        const response = await axios.get(
          `${this.API_URL}users/${userId}/`,
          {
            headers: {
            Authorization: authToken
            }
          }
        );

        console.log("Profile response:", response.data);

        this.profileData = response.data;

        this.description = this.profileData.profile.description;
        this.websiteLink = this.profileData.profile.website_link;

        } catch (error) {
          console.error(
          "Error getting profile:",
          error.response?.data || error
          );
        }
    },*/
    // Post like method
    handleCloseWindow() {
      this.$emit('trigger-close-window')
    },
    toggleProfilePage() {
      this.showProfilePage = !this.showProfilePage;
    },
    // next() {
    //   this.onboarding =
    //     this.onboarding + 1 === this.length ? 0 : this.onboarding + 1
    // },
    // prev() {
    //   this.onboarding =
    //     this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1
    // },
    // Will be used to post the time each article was posted.
    //
    getTime(publishedDate) {
      // Get todays date and the published date and find out how long
      // it's being since the article was posted.
      //
      //const m1 = new Date(); // prints: Toady's date
      console.log(publishedDate)
      moment.locale('en-short');
      const m2 = new Date(publishedDate) // prints: Date of article
      const timeFromNow = moment(m2).fromNow() // Returns date that article was created
      
      return timeFromNow
    },
    createSubstr(authors) {
      console.log(authors)
      if (authors === undefined) {
        return ""
      }
      return authors.substr(0, 22)
    },
    toggleReadMore() {
      this.showFullContent = !this.showFullContent
    },
    createContentSubstr(text) {
      // Limit preview to first 150 characters (adjust as needed)
      return text && text.length > 150 ? text.substring(0, 150) + '...' : text
    },
    // post like
    //
    async likePost(postId) {
      try {

        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        console.log(authToken);

        const response = await axios.post(
          `${this.API_URL}posts/${postId}/toggle-like`,{}, // An empty object as the body, since the API might not require any
          {
            headers: {
              Authorization: authToken
            }
          }
        );
        // Assuming the API returns a boolean or an object with a field like `liked`
        console.log(response)

        if (response.status === 200) {
          this.totalLikes = response.data.likes_count
          this.liked = response.data.is_liked;
        }
      } catch (error) {
        console.error('Error checking user like status:', error);
      }
    },
    // repost method
    async repost(postId) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        //console.log(authToken);
        //console.log(this.API_URL);  
        const response = await axios.post(`${this.API_URL}posts/${postId}/toggle-repost`, {}, {
          headers: { Authorization: authToken },
        });
        if (response.status === 200) {
          this.totalRepost = response.data.reposts_count
          this.reposted = response.data.is_repost;
        }
      } catch (error) {
        console.error('Error reposting:', error);
      }
    },
    // for adding and rendering comments...
    async addComment(postId) {
      console.log(postId);
      console.log(this.comment);

      if (!this.comment) return;

      const newComment = {
        text: this.comment
      };

      let user = localStorage.getItem('user');
      user = JSON.parse(user);

      const authToken = 'Bearer ' + user['access'];
      console.log(authToken);

      try {
        const response = await axios.post(
          `${this.API_URL}posts/${postId}/comments/`,
          newComment,
          {
            headers: {
              Authorization: authToken
            }
          }
        );
        console.log(response);

        // Emit only when the comment is successfully added
        if (response.status === 201) {
          this.$emit('trigger-refresh-posts');
        }
      } catch (error) {
        console.log(error);
      }

      this.comment = "";
    },
    toggleCommentSection() {
      this.showCommentSection = !this.showCommentSection;
    },
    saveArticleAdress(url) {
      this.articleAddress = url;
    },
    toggleNewsPageOverlay() {
      this.showNewsPage = !this.showNewsPage;
    },
    async checkUserLike() {
      try {

        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        console.log(authToken);

        const response = await axios.get(`${this.API_URL}posts/${this.article.id}/user-like-check`,
          {
            headers: {
              Authorization: authToken
            }
          }
        );
        // Assuming the API returns a boolean or an object with a field like `liked`
        console.log(response.data)
        this.liked = response.data.liked;
      } catch (error) {
        console.error('Error checking user like status:', error);
      }
    },
    async checkRepostLike() {
      try {

        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        console.log(authToken);

        const response = await axios.get(`${this.API_URL}posts/${this.article.id}/user-repost-check`,
          {
            headers: {
              Authorization: authToken
            }
          }
        );
        // 
        console.log(response.data)
        this.reposted = response.data.reposted; 
      } catch (error) {
        console.error('Error checking user reposts status:', error);
      }
    },
    // toggleFullScreen() {
    //   this.fullScreen = !this.fullScreen
    // }
  },
  props: {
    
    article: Object,
    countryName: String,
    countryCode: String,
  },

  created() {
    this.totalLikes = this.article.likes
    this.totalRepost = this.article.reposts
    this.getProfileData()
    this.fetchReposts()
    this.checkUserLike()
    this.checkRepostLike()
  },
}
</script>

<style scoped>
.content-with-image {
  display: block;
  text-align: justify;
}

.wrapped-image {
  float: left;
  margin-right: 12px;
  margin-bottom: 8px;
  border-radius: 8px;
}
.reply-box {
  background-color: white !important;
  color: black !important;
  border-radius: 20px;
  width: 100%;
  max-height: 120px;
  overflow-y: auto;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.25s ease;
  z-index: 1000;
}
/* Smooth transition to attach above keyboard on mobile */
@media (max-width: 600px) {
  .reply-box {
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    max-width: 600px;
    border-radius: 25px;
  }
}


.close-button {
  position: absolute;
  top: 10px;
  right: 5px;
}

.max-height-textarea textarea {
  max-height: 105px;
  /* Adjust the desired maximum height here */
  overflow: auto;
}

.full-screen {
  width: 100% !important;
  height: 100% !important;
  top: 50% !important;
  bottom: 0 !important;
}

a:visited {
  color: deepskyblue;
  background-color: transparent;
  text-decoration: none;
}
</style>